module.exports = __webpack_public_path__ + "img/fatture_invoiceweb.fb9eb1f3.png";